import React from "react";
import styles from "./Modal.module.css";
const ModalChildrenContainer = ({ children }) => {
  return <div className={styles["status-container"]}> {children}</div>;
};

export default ModalChildrenContainer;
